/**
 * StepRouter - Sélectionne et affiche le bon widget d'étape selon le type
 * Identique à Flutter StepRouter
 */

import React from 'react';
import GameRegistry from '../systems/GameRegistry';
import {PlayerStep} from '../models/PlayerStep';
import {GameStateStatus} from '../models/GameState';
import BaseStepWidget from './BaseStepWidget';

interface StepRouterProps {
  step: PlayerStep;
}

const StepRouter: React.FC<StepRouterProps> = ({step}) => {
  // Vérifier d'abord le state du gameState avant de vérifier le type de l'étape
  const gameState = step.gameState;
  
  // Essayer d'abord avec le gameState du step
  let currentState: GameStateStatus | undefined;
  if (gameState) {
    currentState = gameState.state;
  }

  // Vérifier le state du gameState en priorité
  if (currentState !== undefined) {
    if (currentState === GameStateStatus.FAILED) {
      try {
        const builder = GameRegistry.getStepBuilder('STEP_FAILED');
        return builder(step);
      } catch (e) {
        console.error(`[StepRouter] Failed to get builder for STEP_FAILED: ${e}`);
      }
    }

    if (currentState === GameStateStatus.SUCCEED) {
      try {
        const builder = GameRegistry.getStepBuilder('STEP_SUCCEED');
        return builder(step);
      } catch (e) {
        console.error(`[StepRouter] Failed to get builder for STEP_SUCCEED: ${e}`);
      }
    }
  }

  // Fallback: vérifier le type de l'étape
  // IMPORTANT: Ne pas afficher FailedStepWidget si le gameState est en PLAYING
  const stepTypeUpper = (step.type || 'STEP_SIMPLE').toUpperCase();
  
  if (currentState !== GameStateStatus.PLAYING) {
    if (stepTypeUpper === 'STEP_FAILED' || stepTypeUpper === 'FAILED') {
      try {
        const builder = GameRegistry.getStepBuilder('STEP_FAILED');
        return builder(step);
      } catch (e) {
        console.error(`[StepRouter] Failed to get builder for STEP_FAILED: ${e}`);
      }
    }

    if (stepTypeUpper === 'STEP_SUCCEED' || stepTypeUpper === 'SUCCEED') {
      try {
        const builder = GameRegistry.getStepBuilder('STEP_SUCCEED');
        return builder(step);
      } catch (e) {
        console.error(`[StepRouter] Failed to get builder for STEP_SUCCEED: ${e}`);
      }
    }
  }

  // Utiliser le type de l'étape (essayer exact, puis majuscule)
  const stepTypeFinal = step.type || 'STEP_SIMPLE';
  try {
    // Essayer d'abord avec le type exact
    const builder = GameRegistry.getStepBuilder(stepTypeFinal);
    return builder(step);
  } catch (e) {
    // Si échec, essayer en majuscule
    try {
      const builder = GameRegistry.getStepBuilder(stepTypeFinal.toUpperCase());
      return builder(step);
    } catch (e2) {
      console.error(`[StepRouter] Failed to get builder for type: ${stepTypeFinal} (tried: ${stepTypeFinal}, ${stepTypeFinal.toUpperCase()})`);
      // Fallback sur BaseStepWidget si aucun builder n'est trouvé
      return <BaseStepWidget step={step} />;
    }
  }
};

export default StepRouter;